import { BaseModel } from '../base-model';
import { UserRole } from '../../enumerations/user-role';

export class User extends BaseModel {
  // Champs d'identification de base
  username: string = '';
  email: string = '';
  role: UserRole | string = UserRole.ADMIN_SITE;
  active: boolean = false;

  // Informations personnelles
  first_name: string = '';
  last_name: string = '';
  phone: string = '';

  // --- CORRECTION : On utilise site_name pour corriger les erreurs TS2551 ---
  site_name: string = '';

  // Champs spécifiques aux types d'utilisateurs
  carte?: string; // Pour les Admin Site
  organisation?: string; // Pour les Abonnés
  adresse?: string; // Pour les Abonnés
  type_abonné?: string; // Pour les Abonnés

  // Métadonnées système
  create_at?: string; // Correspond à create_at dans le JSON Django
  identifier?: string; // Utilisé pour le login

  // Indicateurs de configuration (UI)
  should_change_password: boolean = false;
  should_receive_monthly_report: boolean = false;

  /**
   * Récupère dynamiquement une valeur booléenne par sa clé
   */
  public getObjectValues(key: string): boolean {
    const data: any = { ...this };
    return !!data[key];
  }

  /**
   * Transforme un booléen en texte lisible (Oui/Non)
   */
  public displayConfigValueFromKey(key: string): string {
    return this.getObjectValues(key) ? 'Oui' : 'Non';
  }

  /**
   * Retourne la classe CSS en fonction de l'état d'un booléen
   */
  public displayColorFromKey(key: string): string {
    return this.getObjectValues(key) ? 'bg-success' : 'bg-danger';
  }
}
